import { FunctionComponent } from "react";
import "./TextArea.scss";

interface IProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  icon?: string;
}

const TextArea: FunctionComponent<IProps> = (props) => {
  return (
    <div className={"textarea-field " + props.className}>
      {props.label && (
        <label className="textarea-field__label">{props.label}</label>
      )}
      <textarea className="textarea-field__textarea" {...props} />
      {props.icon ? (
        <span className={"textarea-field__icon icon-" + props.icon}></span>
      ) : (
        ""
      )}
    </div>
  );
};

export default TextArea;
